<template>
  <div class="pageContent">
    <div class="pageTitleBox">
      <img src="../../assets/images/rulers2.png" alt="logo" class="pageTitleIcon">规章制度
    </div>
    <template v-if="loading">
      <div class="listItem" v-for="i in 5" :key="i" style="height:100px;">
        <a-skeleton active :title="false" :paragraph="{rows: 3}" />
      </div>
    </template>
    <div class="listItem" v-for="item in list" :key="item.id">
      <div class="listItemLeft" @click="$router.push({ name: 'rulersDetail', query: { noticeId: item.id, noticeName: item.headline } })">{{ item.headline }}</div>
      <div class="listItemRight">{{ item.addTime }}</div>
    </div>
    <div class="paginationBox">
      <a-pagination size="small" :total="total" :pageSize="5" show-quick-jumper @change="tableChange" />
    </div>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  name: 'xinwen',
  data() {
    return {
      list: [],
      loading: true,
      total: 0,
      pageNum: 1
    }
  },
  created() {
    this.onload()
  },
  methods: {
    onload() {
      let parameter = {
        pageNum: this.pageNum,
        pageSize: 5,
        type: 3
      }
      this.loading = true
      this.list = []
      http('/system/announcement/getList', 'POST', parameter).then(res => {
        this.loading = false
        if (res.success) {
          this.list = res.data.resultList
          this.total = res.data.total
        }
      })
    },
    tableChange(page) {
      this.pageNum = page
      this.onload()
    }
  }
}
</script>

<style lang="less" scoped>
.pageContent {
  width: 1220px;
  margin: 18px auto;
  padding: 0 32px;
}
.listItem {
  height: 59px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  align-items: flex-end;
}
.listItemLeft {
  width: 90%;
  line-height: 59px;
  font-size: 16px;
  color: #333;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.listItemRight {
  line-height: 59px;
  font-size: 16px;
  color: #666;
  font-weight: 400;
  margin-left: 20px;
}
</style>